import { Component, OnInit } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { RealEstate } from './../../models/real-estates/real-estates.model';

@Component({
  selector: 'swb-real-estate-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class RealEstateListComponent extends ListBase<RealEstate> implements OnInit {

  public url = 'estates';
  public urlPrefix = 'estates';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
